/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'dva';

import NProgress from 'nprogress';

import pathToRegexp from 'path-to-regexp';
import classnames from 'classnames';
import storage from 'utils/storage';
import { Modal } from 'antd';
import moment from 'moment';

import { showMultipleSteps, showSingleStep } from 'utils/tour';

import { Header, Bread, Footer, Sider, styles } from 'components/Layout';
import Loader from 'components/Loader';

import 'driver.js/dist/driver.min.css';

import MessageDisplay from '../components/Common/MessageDisplay';
import Error from './error';

import '../themes/index.less';
import './app.less';


let lastHref;
const TOPA_URL = 'https://app.topa.vn';

class AppModal extends React.Component {
  constructor(props) {
    super(props);

    let lastTimeTOPAModalShow = storage.getItem('lastTimeTOPAModalShow');
    let hours = 24;
    if (lastTimeTOPAModalShow) {
      lastTimeTOPAModalShow = moment(lastTimeTOPAModalShow);
      const duration = moment.duration(moment(new Date()).diff(lastTimeTOPAModalShow));
      hours = duration.asHours();
    }

    this.state = {
      show: hours > 2,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.state.show) {
        window.location = TOPA_URL;
      }
    }, 20 * 1000);
  }

  handleOk = () => {
    this.setState({ show: false });
    window.location = TOPA_URL;
  }

  handleCancel = () => {
    this.setState({ show: false });
    storage.setItem('lastTimeTOPAModalShow', moment(new Date()).toISOString());
  }

  render() {
    return (
      <Modal
        title="Thông báo"
        visible={this.state.show}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText="Mở app TOPA"
        cancelText="Bỏ qua"
      >
        <p>Chúng tôi đã nâng cấp phần mềm kế toán online app.1ketoan.com sang phiên bản mới tại địa chỉ <b> <a href={TOPA_URL}>app.topa.vn</a></b> </p>
        <p>Khách hàng vui lòng đăng nhập <b> <a href={TOPA_URL}>APP.TOPA.VN</a></b> với <b>tài khoản hiện tại</b> để upload files, xem sổ sách báo cáo thuế với trải nhiệm tốt nhất.</p>
        <p style={{ padding: '10px 0' }}>Các ưu điểm vượt trội của phần mềm kế toán TOPA:</p>
        <p>1. Miễn phí để sử dụng cho kế toán nội bộ, quản lý thu chi</p>
        <p>2. Theo dõi đồng thời: phân hệ Quản trị (kế toán nội bộ), phân hệ Tài chính (kế toán thuế)</p>
        <p>3. Đầy đủ các phân hệ kế toán và tính năng thông minh khác</p>
        <p style={{ padding: '10px 0' }}>Trân trọng cảm ơn Quý khách hàng!</p>
      </Modal>
    );
  }
}

class App extends React.Component {
  componentDidMount() {
    setTimeout(this.showGuide, 1000);
  }

  showGuide = () => {
    const { tour, dispatch } = this.props;
    if (!tour.guideMainMenu) {
      const steps = [
        {
          element: '#siderMenuItem14',
          popover: {
            title: 'Upload file',
            description: 'Bấm vào đây để quản lý và upload các file, ảnh hóa đơn chứng từ lên phần mềm.',
            position: 'right',
          },
        },
        {
          element: '#siderMenuItem16',
          popover: {
            title: 'Thảo luận với kế toán',
            description: 'Xem các phản hồi và thảo luận với Kế toán viên.',
            position: 'right',
          },
        },
        {
          element: '#siderMenuItem11_1',
          popover: {
            title: 'Báo cáo tổng quan',
            description: 'Thống kê số lượng hóa đơn, tiền thuế phải nộp, trạng thái kho hàng tính tới thời điểm hiện tại.',
            position: 'right',
          },
        },
        {
          element: '#siderMenuItem11_3',
          popover: {
            title: 'Báo cáo thuế hàng Quý',
            description: 'Xem và kiểm tra lại các báo cáo thuế hàng quý đã được lập bởi Kế toán viên.',
            position: 'right',
          },
        },
        {
          element: '#siderMenuItem11_4',
          popover: {
            title: 'Báo cáo tài chính',
            description: 'Xem Bảng cân đối tài khoản và Báo cáo tài chính.',
            position: 'right',
          },
        },
        {
          element: '#siderMenuItem17',
          popover: {
            title: 'Phí dịch vụ',
            description: 'Chi tiết phí dịch vụ Kế toán thuế online và lịch sử thanh toán.',
            position: 'right',
          },
        },
        {
          element: '#resetTourBtn',
          popover: {
            title: 'Xem lại hướng dẫn',
            description: 'Bấm vào đây để xem lại các hướng dẫn này khi bạn cần.',
            position: 'top',
          },
        },

      ];
      showMultipleSteps(steps, () => {
        dispatch({ type: 'tour/updateParams', payload: { guideMainMenu: true } });
      });
    }

    if (tour.guideMainMenu && !tour.guideSelectYear) {
      showSingleStep({
        element: document.querySelector('#selectYear'),
        popover: {
          title: 'Chọn năm',
          description: 'Chọn đúng năm để xem dữ liệu kế toán và báo cáo trong năm đó',
          position: 'bottom-right',
        },
      }, () => {
        dispatch({ type: 'tour/updateParams', payload: { guideSelectYear: true } });
      });
    }
  }

  render() {
    const { children, dispatch, app, loading, location } = this.props;
    const { user, siderFold, darkTheme, isNavbar, menuPopoverVisible, navOpenKeys, menu, accountingPeriod, beginPeriod, settings } = app;

    let pathname = location.pathname;
    if (!pathname.startsWith('/')) {
      pathname = `/${pathname}`;
    }
    const hasPermission = menu.filter(item => pathToRegexp(item.route || '').exec(pathname)).length > 0;

    const href = window.location.href;
    if (lastHref !== href) {
      NProgress.start();
      if (!loading.global) {
        NProgress.done();
        lastHref = href;
      }
    }

    const headerProps = {
      menu,
      user,
      siderFold,
      isNavbar,
      menuPopoverVisible,
      navOpenKeys,
      accountingPeriod,
      beginPeriod,
      switchMenuPopover() {
        dispatch({ type: 'app/switchMenuPopver' });
      },
      logout() {
        dispatch({ type: 'app/logout' });
      },
      switchSider() {
        dispatch({ type: 'app/switchSider' });
      },
      changeOpenKeys(openKeys) {
        dispatch({ type: 'app/handleNavOpenKeys', payload: { navOpenKeys: openKeys } });
      },
      selectPeriod(year) {
        dispatch({ type: 'app/selectPeriod', payload: year });
      },

    };

    const siderProps = {
      menu,
      siderFold,
      darkTheme,
      navOpenKeys,
      changeTheme() {
        dispatch({ type: 'app/switchTheme' });
      },
      changeOpenKeys(openKeys) {
        storage.setItem('navOpenKeys', JSON.stringify(openKeys));
        dispatch({ type: 'app/handleNavOpenKeys', payload: { navOpenKeys: openKeys } });
      },
      resetTourGuide() {
        dispatch({ type: 'tour/reset' });
        window.location.reload();
      },
    };


    if (!loading.appReady) {
      return (
        <div>
          <MessageDisplay />
          <Loader spinning={loading.global || !loading.appReady} />
        </div>);
    }

    const breadProps = { menu, companyName: settings && settings.company_name };

    return (
      <div>
        <MessageDisplay />
        <Helmet>
          <title>1ketoan.com - Kế toán online</title>
          <script src="/iconfont.js" />
          <link rel="stylesheet" href="/iconfont.css" />
        </Helmet>
        <div className={classnames(styles.layout, { [styles.fold]: isNavbar ? false : siderFold }, { [styles.withnavbar]: isNavbar })}>
          {!isNavbar &&
            <aside className={classnames(styles.sider, { [styles.light]: !darkTheme })}>
              <Sider {...siderProps} />
            </aside>
          }
          <div className={styles.main}>
            <AppModal />
            <Header {...headerProps} />
            <Bread {...breadProps} />
            <div className={styles.container}>
              <div className={styles.content}>
                {hasPermission ? children : <Error />}
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element.isRequired,
  location: PropTypes.object,
  dispatch: PropTypes.func,
  app: PropTypes.object,
  loading: PropTypes.object,
};

export default connect(({ app, tour, loading }) => ({ app, tour, loading }))(App);



// WEBPACK FOOTER //
// ./src/routes/app.js